import { computed, useContext, ref, useRouter } from '@nuxtjs/composition-api';
import addWarrantyToCartQuery from '~/components/czar/checkout/cart/addWarrantyToCart.ggl';
import addWarrantyToCartCustomerQuery from '~/components/czar/checkout/cart/addWarrantyToCartCustomer.ggl';
import { useCartStore } from '~/modules/checkout/stores/cart';
import { useCart } from '~/modules/checkout/composables/useCart';
import { useUiState } from '~/composables';
import { useUiNotification } from '~/composables';
import { Logger } from '~/helpers/logger';

export function useExtendWarranty() {
  const warranty_adding = ref<boolean>(false); 
  const context = useContext();
  const cartStore = useCartStore();
  const cart = computed(() => cartStore.cart);
  const queryVariables = ref<Record<string, any>>({});
  const { app } = useContext();
  const context1 = app.$vsf;
  const apiState = context1.$magento.config.state;
  const { load } = useCart();
  const { toggleCartSidebar } = useUiState();
  const { send: sendNotification } = useUiNotification();
  const { app: { i18n } } = useContext();
  const router = useRouter();

  const addWarrantyToCart = async (warrantyData, qty, isAuthenticated) => {
    try { 
      warranty_adding.value = true;
      const cartId = cart.value.id || apiState.getCartId();
      if (!cartId) {
        await load({ realCart: true });
      }
      queryVariables.value = {
        cartId: cart.value.id || apiState.getCartId(),
        warranty: warrantyData,
        qty
      };

      const { data } = await context.app.$vsf.$magento.api.customQuery({
        query: isAuthenticated ? addWarrantyToCartCustomerQuery : addWarrantyToCartQuery,
        queryVariables: queryVariables.value,
      });

      if (data) {
        cartStore.$patch((state) => {
          // @ts-ignore
          state.cart =  data.addWarrantyToCart?.cart;
        });

        toggleCartSidebar();
        addItemNotification();
        warranty_adding.value = false;
      }
    } catch (err) {
      Logger.error('useCart/addItem', err);
    } finally {
      warranty_adding.value = false;
    }
  };

  const addItemNotification = () => {
    sendNotification({
      type: 'success',
      icon: 'check',
      persist: false,
      message: i18n.t("Item added to the cart successfully") as string,                
      action: {
        // @ts-ignore
        text: i18n.t('View'),
        onClick: async () => {  
          await router.push(app.localeRoute({ name: 'cart' }));
        }
      }
    });
  };

  return {
    addWarrantyToCart,
    warranty_adding
  };
};

export default useExtendWarranty;